import { Box } from '@mui/material';
import Autosuggest from 'components/controls/Autosuggest';
import { array, object } from 'prop-types';
import React from 'react';
import APP_SUBSCRIBABLE_EVENTS from 'utils/appSubscribableEvents';
import { I18n } from 'utils/i18n';

const AppEventSuggest = ({ field, form, filterOut = null, ...props }) => {
  const { name, value, onBlur } = field;
  const { errors, submitCount, setFieldValue } = form;
  const { error } = form.getFieldMeta(name);

  let events = APP_SUBSCRIBABLE_EVENTS;
  if (filterOut) {
    events = events.filter(ev => value === ev || !filterOut.includes(ev));
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Autosuggest
        fullWidth
        {...props}
        onChange={e => setFieldValue(name, e.value)}
        onBlur={onBlur}
        value={value}
        name={name}
        error={!!(error && submitCount > 0)}
        helperText={submitCount > 0 && errors[name]}
        placeholder={I18n.t('AppDrawer.SubscribedEventsField.chooseEvent')}
        suggestions={events.map(event => ({
          label: I18n.t(`AppDrawer.SubscribedEventsField.events.${event}`, {
            defaultValue: event,
          }),
          value: event,
        }))}
      />
    </Box>
  );
};

AppEventSuggest.propTypes = {
  field: object.isRequired,
  form: object.isRequired,
  filterOut: array,
};

export default AppEventSuggest;
